import Kraken from '@sfly/px-kraken-ui';

// @ts-expect-error fix this
window.Kraken = Kraken;
export default Kraken;
